import InstantLuckyDrawTable from './instantLuckyDrawTable.container'

export default InstantLuckyDrawTable